/* eslint-disable no-async-promise-executor */
const imageUrl = "https://picsum.photos/200";

// This function fetches the image blob data from the provided URL, with which we can create an image.
function fetchBlobImage() {
  return fetch(imageUrl).then(response => response.blob());
  // return new Promise(async (resolve) => {
  //   const response = await fetch(imageUrl);
  //   const blob = await response.blob();
  //   resolve(blob);
  // });
}

export { fetchBlobImage };